import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorApi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M2.25 4.5A2.25 2.25 0 0 1 4.5 2.25h15a2.25 2.25 0 0 1 2.25 2.25v15a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25v-15Zm2.25-.75a.75.75 0 0 0-.75.75v15c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75h-15Z"
    />
    <path
      fill="#F7A600"
      d="M9.41 14.01H7.736l-.23.99H6l1.79-6h1.605l1.79 6h-1.54l-.234-.99Zm-.308-1.298-.526-2.157-.523 2.157h1.05ZM11.652 9H14.1c.532 0 .93.16 1.195.479.266.32.4.773.4 1.363 0 .605-.146 1.079-.436 1.42-.288.341-.728.511-1.322.511h-.806V15h-1.478V9Zm1.479 2.558h.36c.284 0 .483-.061.598-.184a.682.682 0 0 0 .172-.479.768.768 0 0 0-.15-.479c-.1-.13-.286-.196-.562-.196h-.418v1.338ZM16.525 9H18v6h-1.475V9Z"
    />
  </svg>
);
export default SvgTwoColorApi;
